import './profile_form.css';
import { BarLoader } from '../BarLoader/BarLoader';
import { forwardRef, useEffect, useState } from "react";
import { useAuth } from '../../context/AuthContext';
import { useServer } from '../../context/serverContext';
import { endpoints } from '../../env';
import { useLang } from '../../context/LangContext';

export const ProfileForm = forwardRef((props, ref) => {
    const { user, checkAuth } = useAuth();
    const { postRequest } = useServer();
    const { lang } = useLang();

    //STATES
    const [loading, setLoading] = useState(true);
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [langUser, setLangUser] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    //FUNCTIONS
    const discardChanges = () => {
        setEmail(user.email);
        setName(user.name);
        setLangUser(user.lang);
        setErrorMsg("");
    }

    const update = () => {
        if (loading) {
            return;
        }

        setLoading(true);
        setErrorMsg("");

        let data = {
            user_id: user.id,
            name: name,
            lang: langUser,
        }

        postRequest(endpoints.updateUser, data, (res) => {
            setLoading(false);
            if (res[0]) {
                res = res[1];
                checkAuth();
            } else {
                if (lang === "en") {
                    setErrorMsg("Server error, try again in a bit");
                } else {
                    setErrorMsg("Error del servidor, intente de nuevo en un momento");
                }
            }
        });
    }

    //EFFECTS
    useEffect(() => {
        if (user !== null) {
            setLoading(false);

            if (email === "") {
               setEmail(user.email);
            }

            if (name === "") {
                setName(user.name);
            }

            if (langUser === "") {
                setLangUser(user.lang);
            }
        }
    }, [user]);

    
    return (
        <>
            <div className="profile_form">
                <div className='input_container'>
                    <label>
                        { lang === "en" ? "Name" : "Nombre"}
                    </label>
                    <input type='text' placeholder={ lang === "en" ? "Name" : "Nombre"} disabled={loading} value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                <div className='input_container'>
                    <label>
                        { lang === "en" ? "Email" : "Correo electrónico"}
                    </label>
                    <input type='text' placeholder={ lang === "en" ? "Email" : "Correo electrónico"} disabled value={email} />
                </div>
                <div className='input_container'>
                    <label>
                        { lang === "en" ? "Languaje" : "Idioma"}
                    </label>
                    <select disabled={loading} onChange={(e) => {setLangUser(e.target.value)}}>
                        <option value='es' selected={langUser === 'es'}>Español</option>
                        <option value='en' selected={langUser === 'en'}>English</option>
                    </select>
                </div>
                {loading && 
                    (
                        <div className='loader'>
                            <BarLoader />
                        </div>
                    )
                }

                {errorMsg !== "" &&
                    (
                        <div className='error_msg'>
                            {errorMsg}
                        </div>
                    )
                }
                
                <div className='actions'>
                    <button disabled={loading} onClick={discardChanges}>
                        { lang === "en" ? "Discard changes" : "Descartar cambios"}
                    </button>
                    <button className='primary' disabled={loading} onClick={update}>
                        { lang === "en" ? "Save changes" : "Guardar cambios"}
                    </button>
                </div>
            </div>
        </>
    );
});